import { useEffect } from 'react';

export const useIframeRefresh = () => {
    useEffect(() => {
        const isInIframe = window.parent && window.parent !== window;

        const handleKeyDown = (event) => {
            const isRefreshShortcut = 
                ((event.ctrlKey || event.metaKey) && event.key === 'r') ||
                (event.key === 'F5') ||
                ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'R');

            if (isRefreshShortcut) {
                event.preventDefault();
                event.stopPropagation();
                
                if (isInIframe) {
                    // Ask parent to refresh the iframe
                    window.parent.postMessage({ 
                        type: 'REQUEST_IFRAME_REFRESH',
                        source: 'ukies-webinars',
                        timestamp: Date.now()
                    }, '*');
                } else {
                    window.location.reload();
                }
                
                return false;
            }
        };

        const handleMessage = (event) => {
            if (event.data.type === 'REFRESH_IFRAME' && event.data.target === 'ukies-webinars') {
                // Send confirmation that we received the message
                window.parent.postMessage({
                    type: 'REFRESH_STARTED',
                    source: 'ukies-webinars',
                    timestamp: Date.now()
                }, '*');
                
                // Small delay to ensure message is sent before reload
                setTimeout(() => {
                    window.location.reload();
                }, 10);
            }
        };

        // Add event listeners
        document.addEventListener('keydown', handleKeyDown, true);
        window.addEventListener('message', handleMessage);

        // Notify parent that iframe is ready
        if (isInIframe) {
            window.parent.postMessage({ 
                type: 'IFRAME_READY',
                source: 'ukies-webinars',
                url: window.location.href,
                timestamp: Date.now()
            }, '*');
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
            window.removeEventListener('message', handleMessage);
        };
    }, []);
};